<div *transloco="let t;">
  <app-dialog-title>
    {{ isAdd ? t('settings.add-user') : t('settings.remove-user') | transloco }}
  </app-dialog-title>

  <mat-dialog-content>
    <div class="content">
      <form [formGroup]="form" class="ui form">
          <div class="field">
              <label>{{ 'settings.email' | transloco }}</label>
              <input
                formControlName="email"
                class="form-control" />
          </div>
          <div class="field">
            <label>{{ 'settings.first-name' | transloco }}</label>
            <input
              formControlName="firstName"
              class="form-control" />
          </div>
          <div class="field">
            <label>{{ 'settings.last-name' | transloco }}</label>
            <input
              formControlName="lastName"
              class="form-control" />
          </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <a class="go-back cancel" (click)="onClose()">{{ t('settings.cancel') | transloco }}</a>
    <button
      [disabled]="form.invalid"
      (click)="save()"
      class="ui primary button"
    >
      {{ isAdd ? t('settings.add-user') : t('settings.remove-user') | transloco }}
    </button>
  </mat-dialog-actions>
</div>
